import { TextInput, MaskedInput, Select } from "components/inputs";

import type { SubPageType } from "types/FormTypes";
import type { ConstantTypes } from "types/DataTypes";

export const getAdjusterForm = (
  constants: ConstantTypes,
  readOnly: boolean,
): SubPageType[] => {
  return [
    {
      name: "Adjusters",
      stepNumber: 1,
      path: "adjusters/:adjusterId/overview",
      cards: [
        {
          cardNumber: 1,
          cardName: "Adjuster Information",
          fields: [
            {
              label: "Name",
              component: TextInput,
              apiField: "name",
              componentProps: {
                placeholder: "Name",
                readOnly,
                disabled: readOnly,
              },
            },
            {
              label: "Email",
              component: TextInput,
              apiField: "email",
              componentProps: {
                placeholder: "Email",
                readOnly,
                disabled: readOnly,
              },
            },
            {
              label: "Phone",
              component: MaskedInput,
              apiField: "phone",
              componentProps: {
                placeholder: "Phone Number",
                readOnly,
                disabled: readOnly,
                mask: "phone",
              },
            },
          ],
        },
        {
          cardNumber: 2,
          cardName: "Address",
          fields: [
            {
              label: "Address Line 1",
              component: TextInput,
              apiField: "address1",
              componentProps: {
                placeholder: "Street Address",
                readOnly,
                disabled: readOnly,
              },
            },
            {
              label: "Address Line 2",
              component: TextInput,
              apiField: "address2",
              componentProps: {
                placeholder: "Apartment, suite, etc.",
                readOnly,
                disabled: readOnly,
              },
            },
            {
              label: "City",
              component: TextInput,
              apiField: "city",
              componentProps: {
                placeholder: "City",
                readOnly,
                disabled: readOnly,
              },
            },
            {
              label: "State",
              component: Select,
              apiField: "state",
              componentProps: {
                placeholder: "Select State",
                options: constants?.STATES,
                isDisabled: readOnly,
              },
            },
            {
              label: "ZIP Code",
              component: MaskedInput,
              apiField: "zip",
              componentProps: {
                placeholder: "ZIP Code",
                readOnly,
                disabled: readOnly,
                mask: "zipcode",
              },
            },
          ],
        },
        {
          cardNumber: 3,
          cardName: "History",
          fields: [
            {
              label: "Created Date",
              component: TextInput,
              apiField: "created",
              componentProps: {
                readOnly: true,
                roundDate: true,
              },
            },
            {
              label: "Last Updated Date",
              component: TextInput,
              apiField: "modified",
              componentProps: {
                readOnly: true,
                roundDate: true,
              },
            },
          ],
        },
      ],
    },
  ];
};
